export default __webpack_public_path__ + "026cbce13cda4ab885bf1350b873086f.ttf";